import { Toast } from '@fattureincloud/fic-design-system'
import { faArrowFromLeft } from '@fortawesome/pro-light-svg-icons'
import React, { FC } from 'react'

import { httpRequest } from '../../common/network'
import { Button } from '../../layout_components/Button'
import { errorMessage, locale } from '../../locales/locale'
import { disableAdminMode } from '../../redux/features/adminMode/adminModeSlice'
import { disableEditor } from '../../redux/features/editor/editorSlice'
import { setCompany } from '../../redux/features/visualizationMode/visualizationModeSlice'
import { useAppDispatch } from '../../redux/hooks'
import LanguageSwitcher from '../LanguageSwitcher'
import { CloseEditorContainer } from './exitoedtormode.components'

interface Props {
  buttonClass: string
}

export const ExitEditorMode: FC<Props> = (props: Props) => {
  const dispatch = useAppDispatch()

  const close = () => {
    httpRequest({
      method: 'GET',
      path: 'help/admin_mode/exit',
      onSuccess: () => {
        dispatch(disableEditor())
        dispatch(disableAdminMode())
        dispatch(setCompany())
      },
      onError: (res) => {
        Toast.error(errorMessage, { content: res.message })
      },
    })
  }
  return (
    <CloseEditorContainer>
      <Button
        text={locale('Chiudi modalità editor')}
        type={'text'}
        iconLeft={faArrowFromLeft}
        onClick={close}
        customClass={props.buttonClass}
      />
      {process.env.REACT_APP_ENV != 'production' && <LanguageSwitcher />}
    </CloseEditorContainer>
  )
}

export default ExitEditorMode
